import React, {useEffect, useState} from "react";
import {HistoryFilterModel} from "../../../../shared/models/order/history-filter.model";
import {useAppSelector} from "../../../../../redux/store";
import {CustomerFilterModel} from "./customer-filter";
import BarekamInput from "../../../../components/input";
import {getMessage} from "../../../../shared/helper-functions";
import {MessageSections} from "../../../../components/message/message";
import {GapContainer} from "../../../../components/card/styled";

export const HistorySearchInput = ({filter, filterChanged}: SearchInputProps) => {
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    const [userTextQuery, setUserTextQuery] = useState(filter.userIdentity || '');
    const [orderTextQuery, setOrderTextQuery] = useState(filter.orderIdentity || '');

    const [searchTimeoutId, setSearchTimeoutId] = useState<any>();

    useEffect(() => {
        setUserTextQuery(filter.userIdentity || '');
        setOrderTextQuery(filter.orderIdentity || '');
    }, [filter])

    function onSearchQueryKeyUp(field: 'userIdentity' | 'orderIdentity', key: string) {
        if (key === 'Enter') {
            clearTimeout(searchTimeoutId);

            setFilterWithQuery(field, field === 'userIdentity' ? userTextQuery : orderTextQuery);
        }
    }
    function setFilterWithQuery(field: 'userIdentity' | 'orderIdentity', query: string) {
        const filterClone = {...filter};

        if (field === 'userIdentity') {
            if (query) {
                filterClone.userIdentity = query;
            } else {
                delete filterClone.userIdentity;
            }
        } else {
            if (query) {
                filterClone.orderIdentity = query;
            } else {
                delete filterClone.orderIdentity;
            }
        }

        filterChanged(filterClone);
    }

    function onSearchQueryChange(field: 'userIdentity' | 'orderIdentity', query: string) {
        clearTimeout(searchTimeoutId);

        if (field === 'userIdentity') {
            setUserTextQuery(query);
        } else {
            setOrderTextQuery(query);
        }

        const newTimeoutId = setTimeout(() => {
            setFilterWithQuery(field, query);
        }, 3000);

        setSearchTimeoutId(newTimeoutId);
    }

    return (
        <GapContainer style={{gap: '1rem'}}>
            <BarekamInput key={'userIdentity'}
                          customInputVariant={"search"}
                          placeholder={getMessage('user_identity', MessageSections.MAIN, messageCache, languageId)}
                          value={userTextQuery || ''}
                          onChange={(event) => onSearchQueryChange('userIdentity', event.target.value)}
                          onKeyUp={(event) => onSearchQueryKeyUp('userIdentity', event.key)}
                          width={'50%'}/>

            <BarekamInput key={'orderIdentity'}
                          customInputVariant={"search"}
                          placeholder={getMessage('order_identity', MessageSections.MAIN, messageCache, languageId)}
                          value={orderTextQuery || ''}
                          onChange={(event) => onSearchQueryChange('orderIdentity', event.target.value)}
                          onKeyUp={(event) => onSearchQueryKeyUp('orderIdentity', event.key)}
                          width={'50%'}/>
        </GapContainer>
    )
}

interface SearchInputProps {
    filter: HistoryFilterModel,
    filterChanged: (filter: CustomerFilterModel | HistoryFilterModel) => void;
}